import type { ReactNode } from 'react'
import { toast } from 'sonner'
import i18n from '@/lib/i18n'

/**
 * Error toast for a failed flash or hast creation. A failed creation has no document to open,
 * but on CreateAssignmentError the document exists outside any planning, so it gets openAction.
 */
export const toastCreationError = (error: Error, docType: string, openAction: ReactNode): void => {
  if (error.message === 'FlashCreationError' || error.message === 'HastCreationError') {
    toast.error(i18n.t('errors:messages.documentCreationFailed', { type: docType }))
  }

  if (error.message === 'CreateAssignmentError') {
    toast.error(
      i18n.t('errors:messages.documentCreatedAssignmentFailed', { type: docType }),
      { action: openAction }
    )
  }
}
